import { Metamodel } from 'shell-models-lib';
import { DataFlowDatasetSettings, DatasetFormatType } from './dataflow-dataset-settings';
import { DataFlowExpression } from '../dataflowexpression';
import { DataFlowSource } from '../dataflow-source';
import { DataFlowSink } from '../dataflow-sink';
import { adfModelTypeMap } from '../../../registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.adobeIOEvents.dataflowSettings
})
export class AdobeEventsSettings extends DataFlowDatasetSettings {
    @Metamodel.attribute({
    })
    public lastPosition: DataFlowExpression;

    @Metamodel.attribute({
    })
    public batchSize: DataFlowExpression;

    @Metamodel.attribute({
    })
    public requestInterval: DataFlowExpression;

    public get transform(): DataFlowSource | DataFlowSink {
        return this.owner instanceof DataFlowSource ? this.owner as DataFlowSource : this.owner as DataFlowSink;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.AdobeIOEvents;
    }

    public getSubFormat(): string {
        return undefined;
    }

    public getDatasetType(): string {
        return undefined;
    }

    public getIconClass(): string {
        return 'i-20x20-adobe-integration';
    }

    public initialize(subFormat: string): void {
        this.lastPosition = this.transform.createTemplatableExpression();
        this.batchSize = this.transform.createTemplatableExpression();
        this.requestInterval = this.transform.createTemplatableExpression();
    }
}
